import {
  AddButton,
  Button,
  Checkbox,
  DatePicker,
  FormSection,
  Modal,
  Select,
  TextField,
  Tooltip,
  TrashButton,
} from "components/Core"
import { Controller } from "react-hook-form"
import { item_status } from "./presale_item.config"
import { Fragment, useEffect, useRef, useState } from "react"
import useSearchMiddlewareOSRM from "hooks/useSearchMiddlewareOSRM"
import Swal from "sweetalert2"
import BadgeAlertForm from "components/Core/Form/BadgeAlertForm"
import usePreRender from "hooks/usePreRender"
import { IoSearch } from "react-icons/io5"
import cn from "classnames"

interface IFormPresaleItem {
  control: any
  errors: any
  watch: any
  setValue: any
  register: any
  item?: any
}

const FormPresaleItem = ({ control, errors, watch, setValue, item }: IFormPresaleItem) => {
  const values = watch()
  const { _color } = usePreRender()
  const modal_ref = useRef<any>(null)
  const check_query_ref = useRef<any>(null)
  const [loading_get_items, set_loading_get_items] = useState<boolean>(false)
  const [selected_items, set_selected_items] = useState<Array<any>>(values?.items || [])
  const [available_items, set_available_items] = useState([])
  const [channels, set_channels] = useState([])
  const { data: data_channels, search_osrm_action: search_osrm_action_channels } = useSearchMiddlewareOSRM({
    entity: "channels",
  })
  const { action_search_osrm_action } = useSearchMiddlewareOSRM({
    entity: "items",
  })
  const items_query = watch("items_query")
  const find_by_sku = watch("find_by_sku")

  let initDate = item?.custom?.presale?.initDate || ""
  let endDate = item?.custom?.presale?.endDate || ""
  let baseScheduleDate = item?.custom?.presale?.baseScheduleDate || ""
  let stockDate = item?.custom?.presale?.stockDate || ""

  useEffect(() => {
    if (item) {
      set_selected_items([item])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  useEffect(() => {
    setValue("items", selected_items)
    // eslint-disable-next-line
  }, [selected_items])

  useEffect(() => {
    search_osrm_action_channels({ from: 0, size: 1000, fields: ["id", "name"] })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const get_channels_action = async () => {
      let channels_from_req = data_channels?.records
      set_channels(
        channels_from_req?.map((chl: any) => ({
          id: chl?.id,
          label: `${chl?.id} -> "${chl?.name}"`,
          value: chl?.id,
        })),
      )
    }
    get_channels_action()
    // eslint-disable-next-line
  }, [data_channels])

  const find_items_action = async () => {
    try {
      set_available_items([])
      set_loading_get_items(true)
      modal_ref.current?.open()
      let _params: any = {
        from: 0,
        size: 100,
        filters: {},
      }
      if (find_by_sku) {
        Object.assign(_params?.filters, {
          sku: items_query,
        })
      } else {
        Object.assign(_params, {
          queryString: items_query,
        })
      }
      const res: any = await action_search_osrm_action("items", _params)
      if (Boolean(res?.data?.message?.size)) {
        const items = res.data.message.records
        set_available_items(items)
      } else {
        set_available_items([])
      }
      set_loading_get_items(false)
    } catch (error: any) {
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      set_loading_get_items(false)
    }
  }

  const add_item_form = (item: any) => {
    set_selected_items([...selected_items, item])
  }

  const delete_item_form = (item: any) => {
    const updated_items = selected_items.filter((_item: any) => _item.sku !== item.sku)
    set_selected_items(updated_items)
  }

  const validationsSectionsErrors = {
    1: Boolean(["status"].some((key: string) => Object.keys(errors).includes(key))),
    2: Boolean(["items"].some((key: string) => Object.keys(errors).includes(key))),
    3: Boolean(
      ["initDate", "endDate", "baseScheduleDate", "stockDate"].some((key: string) => Object.keys(errors).includes(key)),
    ),
    4: Boolean(["channel"].some((key: string) => Object.keys(errors).includes(key))),
  }

  return (
    <Fragment>
      <div className="w-full flex flex-col items-center gap-4">
        <FormSection
          title="Información general"
          helperText="Información general"
          number={1}
          anyError={validationsSectionsErrors[1]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <div className="w-full flex flex-col lg:flex-row gap-4">
              <div className="w-full flex flex-col gap-2">
                <label className="text-sm text-gray-700">Estado preventa</label>
                <Controller
                  name="status"
                  control={control}
                  defaultValue=""
                  render={({ field: { onChange, value } }) => (
                    <Select options={item_status} label="Estado preventa" onChange={onChange} value={value} />
                  )}
                />
              </div>
            </div>
          </div>
        </FormSection>
        <FormSection
          title="Artículos preventa"
          helperText="Artículos preventa"
          number={2}
          anyError={validationsSectionsErrors[2]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <div className="w-full flex flex-col lg:flex-row gap-4">
              <Controller
                name="items_query"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField label="Buscar artículo..." onChange={onChange} value={value} />
                )}
              />
              <Tooltip content="Buscar" align="top">
                <button
                  type="button"
                  onClick={find_items_action}
                  className={cn(
                    "flex hover:opacity-70 border border-transparent px-4 py-2 rounded-lg cursor-pointer",
                    `bg_${_color} hover:border_${_color}`,
                  )}
                >
                  <IoSearch className="text-xl font-semibold text-white" />
                  <span className="text-white text-base font-medium ml-1">Buscar</span>
                </button>
              </Tooltip>
            </div>
            <div className="flex flex-row items-center justify-start -mt-2 ml-1">
              <Controller
                name="find_by_sku"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <Checkbox ref={check_query_ref} name="find_by_sku" onSelect={onChange} checked={value} />
                )}
              />
              <label
                className="ml-2 text-sm text-gray-700 cursor-pointer"
                onClick={() => check_query_ref?.current?.click()}
              >
                Búsqueda por SKU
              </label>
            </div>
            <div className="w-full flex flex-col gap-2">
              {selected_items?.length ? (
                <div className="w-full flex flex-col gap-2">
                  {selected_items?.map((item: any) => (
                    <div
                      className="w-full grid grid-cols-1 md:grid-cols-[3fr_1fr_auto] items-start md:items-center gap-4 border-b border-gray-200 pb-4 md:pb-2"
                      key={item?.sku}
                    >
                      <p>
                        <span className="font-semibold italic">{item?.sku}</span>, {item?.name}
                      </p>
                      <TrashButton label="" onClick={() => delete_item_form(item)} />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500">No hay artículos seleccionados</p>
              )}
            </div>
            {validationsSectionsErrors[2] ? <BadgeAlertForm /> : null}
          </div>
        </FormSection>
        <FormSection
          title="Fechas preventa"
          helperText="Fechas preventa"
          number={3}
          anyError={validationsSectionsErrors[3]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <Controller
              name="initDate"
              control={control}
              render={({ field: { onChange } }) => (
                <DatePicker onChange={onChange} label="Fecha inicio preventa" defaultValue={initDate} />
              )}
            />
            <Controller
              name="endDate"
              control={control}
              render={({ field: { onChange } }) => (
                <DatePicker onChange={onChange} label="Fecha fin preventa" defaultValue={endDate} />
              )}
            />
            <Controller
              name="baseScheduleDate"
              control={control}
              render={({ field: { onChange } }) => (
                <DatePicker onChange={onChange} label="Fecha preventa agendamiento" defaultValue={baseScheduleDate} />
              )}
            />
            <Controller
              name="stockDate"
              control={control}
              render={({ field: { onChange } }) => (
                <DatePicker onChange={onChange} label="Fecha stock real" defaultValue={stockDate} />
              )}
            />
          </div>
        </FormSection>
        <FormSection
          title="Canales disponibles para preventa"
          helperText="Canales disponibles para preventa"
          number={4}
          anyError={validationsSectionsErrors[4]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <div className="w-full flex flex-col gap-2">
              <label className="text-sm text-gray-700">Canales</label>
              <Controller
                name="channel"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <Select multi label="Canales" options={channels} onChange={onChange} value={value} withSearch />
                )}
              />
            </div>
          </div>
          {validationsSectionsErrors[4] ? <BadgeAlertForm /> : null}
        </FormSection>
      </div>
      <Modal ref={modal_ref}>
        <div className="flex flex-col min-w-96 max-w-2xl max-h-[600px] lg:w-auto">
          <div className={cn("w-full text-center rounded-t-xl p-2", `bg_${_color}`)}>
            <h4 className="text-lg font-medium uppercase text-white">{`Resultados por: ${items_query}`}</h4>
          </div>
          <div className="w-full flex flex-col rounded-b-xl gap-4 px-4 py-6">
            {loading_get_items ? (
              <p className="text-center">Espere...</p>
            ) : !loading_get_items && available_items.length ? (
              <div className="w-full flex flex-col gap-2 overflow-y-scroll max-h-[450px]">
                {available_items?.map((item: any) => (
                  <div
                    className="w-full flex flex-col items-center md:justify-between md:flex-row gap-4 border-b border-gray-200 pb-2"
                    key={item?.sku}
                  >
                    <p>
                      <span className="font-semibold italic">{item?.sku}</span>, {item?.name}
                    </p>
                    {selected_items?.find((_item: any) => _item?.sku === item?.sku) ? (
                      <TrashButton label="Eliminar" onClick={() => delete_item_form(item)} />
                    ) : (
                      <AddButton label="Agregar" onClick={() => add_item_form(item)} />
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500">No se encontraron artículos</p>
            )}
            <div className="flex flex-row justify-end items-end">
              <Button label="Ok" onClick={() => modal_ref.current?.close()} />
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default FormPresaleItem
